import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { EPartialCheckboxValue } from '../../../enums/EPartialCheckboxValue';
import { NestedCheckboxModel } from '../../../models/NestedCheckboxModel';
import { SearchLabelService } from '../../SearchLabelService';
export var NestedCheckboxesService = /*#__PURE__*/function () {
  function NestedCheckboxesService(group) {
    _classCallCheck(this, NestedCheckboxesService);

    _defineProperty(this, "group", void 0);

    _defineProperty(this, "nestedCheckboxesCheckedAmount", 0);

    _defineProperty(this, "nestedCheckboxes", Array.of());

    this.group = group;
  }

  _createClass(NestedCheckboxesService, [{
    key: "calcFields",
    value: function calcFields(searchValue, idsCollection) {
      var _this = this;

      this.nestedCheckboxesCheckedAmountReset();
      this.nestedCheckboxes = this.group.items.reduce(function (nestedCheckboxesAccumulator, item) {
        var nestedSearchLabelService = new SearchLabelService(item.label, searchValue);
        var checked = idsCollection.has(item.value);

        if (checked) {
          _this.nestedCheckboxesCheckedAmountIncrement();
        }

        if (nestedSearchLabelService.needAddCheckbox()) {
          nestedCheckboxesAccumulator.push(new NestedCheckboxModel(item, nestedSearchLabelService.getLabelWithMarks(), checked));
        }

        return nestedCheckboxesAccumulator;
      }, Array.of());
      return this;
    }
  }, {
    key: "titledCheckboxValue",
    get: function get() {
      var result;

      if (!this.nestedCheckboxesCheckedAmount) {
        result = EPartialCheckboxValue.None;
      } else if (this.nestedCheckboxesCheckedAmount === this.group.items.length) {
        result = EPartialCheckboxValue.All;
      } else {
        result = EPartialCheckboxValue.Partial;
      }

      return result;
    }
  }, {
    key: "nestedCheckboxesCheckedAmountIncrement",
    value: function nestedCheckboxesCheckedAmountIncrement() {
      this.nestedCheckboxesCheckedAmount += 1;
      return this;
    }
  }, {
    key: "nestedCheckboxesCheckedAmountReset",
    value: function nestedCheckboxesCheckedAmountReset() {
      this.nestedCheckboxesCheckedAmount = 0;
      return this;
    }
  }]);

  return NestedCheckboxesService;
}();